import { render, staticRenderFns } from "./tableButton.vue?vue&type=template&id=f3ae0bd0&"
import script from "./tableButton.vue?vue&type=script&lang=ts&"
export * from "./tableButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports